exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{box-sizing:border-box;user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}canvas{display:block}body{background-color:#ddd;font-size:110%;font-family:Special Elite,Courier;margin:0}h1{text-align:center}a{text-decoration:none;color:red}ul{text-align:left}input{border:0;padding:.625em;font-family:Courier;font-size:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/00-defaults.css
// module id = 23
// module chunks = 0